import { useState } from "react";
import { useLang, t, LangSwitch } from "../i18n.jsx";

// Iconițe inline (contur lucide, portate ca SVG simplu — fără dependență
// npm nouă). Folosite doar în bara de sus, așa că stau lângă Shell.
const __ic = (kids) => (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || 16}
    height={props.size || 16}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={props.className}
  >
    {kids.map(([Tag, attrs], i) => <Tag key={i} {...attrs} />)}
  </svg>
);
const Bell = __ic([["path", { d: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" }], ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0" }]]);
const Key = __ic([["circle", { cx: 8, cy: 15, r: 4 }], ["path", { d: "m10.85 12.15 8.9-8.9" }], ["path", { d: "m18 5 2 2" }], ["path", { d: "m15 8 2 2" }]]);
const LogOut = __ic([["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" }], ["polyline", { points: "16 17 21 12 16 7" }], ["line", { x1: 21, y1: 12, x2: 9, y2: 12 }]]);

// ────────────────────────────────────────────────────────────────────────
// Shell — bara de sus + navigare, randată imediat după autentificare
// (eager, importată direct din App.jsx), pentru că trebuie vizibilă cât
// timp chunk-ul lazy al vederii curente (Clienți/Evaluare/Ghid) se încarcă.
// ────────────────────────────────────────────────────────────────────────
export default function Shell({ user, onLogout, onHome, onGhid, children }) {
  const { lang } = useLang();
  const [showNotif, setShowNotif] = useState(false);
  const [showSecurity, setShowSecurity] = useState(false);

  return (
    <>
      <div className="topbar">
        <div style={{ display: "flex", alignItems: "center", gap: "1.4em", minWidth: 0 }}>
          <div className="brand clickable" onClick={onHome}>
            <span className="mark">T</span>
            TSRA
          </div>
          <button className="btn btn-ghost" onClick={onGhid}>{t(lang, "Ghid metodologie")}</button>
          <span className="made-by">Made by <b>WKC</b></span>
          <span className="pill">{user.fullName} · {user.role}</span>
        </div>
        <div className="topbar-actions">
          <LangSwitch className="topbar-lang" />
          <div className="topbar-icon-wrap">
            <button
              type="button"
              className="icon-btn"
              onClick={() => { setShowNotif((s) => !s); setShowSecurity(false); }}
              aria-label={t(lang, "Notificări")}
              title={t(lang, "Notificări")}
            >
              <Bell size={16} />
            </button>
            {showNotif && (
              <div className="icon-panel">
                <p className="icon-panel-title">{t(lang, "Notificări")}</p>
                <p className="icon-panel-empty">{t(lang, "Nicio notificare încă.")}</p>
              </div>
            )}
          </div>
          <div className="topbar-icon-wrap">
            <button
              type="button"
              className="icon-btn-label"
              onClick={() => { setShowSecurity((s) => !s); setShowNotif(false); }}
            >
              <Key size={16} />
              {t(lang, "Securitate cont")}
            </button>
            {showSecurity && (
              <div className="icon-panel">
                <p className="icon-panel-title">{t(lang, "Securitate cont")}</p>
                <div className="icon-panel-row"><span>{t(lang, "Cont")}</span><b>{user.email}</b></div>
                <div className="icon-panel-row"><span>{t(lang, "Rol")}</span><b>{user.role}</b></div>
              </div>
            )}
          </div>
          <button type="button" className="icon-btn-label" onClick={onLogout}>
            <LogOut size={16} />
            {t(lang, "Ieșire")}
          </button>
        </div>
      </div>
      <main>{children}</main>
    </>
  );
}
